// ----------- import external dependencies ---------
import React from "react";
import { Menu, Dropdown } from "antd";
import { DownOutlined, PoweroffOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

// ------------ import internal dependencies -----------
import "./header.scoped.css";
import useSchoolAuth from "../../hooks/useAuth";

type headerProps = {
  heading: string;
};

function Header({ heading }: headerProps) {
  // ------------ intialize conponent custom hooks -----------
  const { logout } = useSchoolAuth();
  const navigate = useNavigate();

  /**
   * Handle user logout from the system
   */
  const logoutUser = () => {
    logout();
    navigate("/login", { replace: true });
  };

  /**
   * User dropdown menu ui
   */
  function userMenu() {
    return (
      <Menu>
        <Menu.Item key={0}>
          <span onClick={logoutUser}>
            <PoweroffOutlined /> &nbsp; Logout
          </span>
        </Menu.Item>
      </Menu>
    );
  }

  return (
    <>
      <div className="header-wrapper">
        <div className="header-left-section">
          <h1 className="text-xl font-bold text-offBlack">{heading}</h1>
          <div className="global-search">
            <span className="material-icons-outlined text-xl text-offGrey">
              search
            </span>
            <input type="search" placeholder="Search something here..." />
          </div>
        </div>
        <div className="header-right-section">
          <div className="message-notification">
            <span className="material-icons-outlined cursor-pointer text-offBlack">
              mail_outline
            </span>
            <span className="indicator message--indicator" />
          </div>
          <div className="app-notification">
            <span className="material-icons-outlined cursor-pointer text-offBlack">
              notifications
            </span>
            <span className="indicator app-indicator" />
          </div>
          <Dropdown overlay={userMenu}>
            <div className="user-detail">
              <img
                src="/asset/img/user.png"
                alt="user avatar"
                className="cursor-pointer"
              />
              <span className="text-secureSchool cursor-pointer font-medium text-offBlack">
                Harold Monu
              </span>
              <DownOutlined style={{ fontSize: "14px" }} />
            </div>
          </Dropdown>
        </div>
      </div>
    </>
  );
}

export default Header;
